import { render, staticRenderFns } from "./DealerSmallReview.vue?vue&type=template&id=e78ff1a4&scoped=true"
import script from "./DealerSmallReview.vue?vue&type=script&lang=js"
export * from "./DealerSmallReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e78ff1a4",
  null
  
)

export default component.exports